import {isPolishLanguage} from 'src/app/shared/language-extensions/is-polish-language.language-extension';
import {LanguageType} from 'src/metronic/core/_config/i18n/language-type.model';
import {EnrollmentDTO} from './enrollment-data.model';
import {DegreeName, LanguageName, LocalizationName, ModeName, StudyName, TypeName} from './enrollment-enums.model';

export class Enrollment {
  nameTranslateKey: string;
  modeTranslateKey: string;
  typeTranslateKey: string;
  degreeTranslateKey: string;
  languageTranslateKey: string;
  localizationTranslateKey: string;
  postgraduateStudyName?: string;

  constructor(enrollmentDTO: EnrollmentDTO) {
    // if there's no name representation in an enum then these are some postgraguate studies and their name comes from the server.
    this.nameTranslateKey = StudyName[enrollmentDTO.name];
    this.modeTranslateKey = ModeName[enrollmentDTO.mode];
    this.typeTranslateKey = TypeName[enrollmentDTO.type];
    this.languageTranslateKey = LanguageName[enrollmentDTO.language];
    this.localizationTranslateKey = LocalizationName[enrollmentDTO.localization];
    this.postgraduateStudyName = enrollmentDTO.postgraduateStudyName;

    switch (TypeName[enrollmentDTO.type]) {
      case TypeName.Engineer:
      case TypeName.Bachelor:
      case TypeName.UniformMasters:
        this.degreeTranslateKey = DegreeName.First;
        break;
      case TypeName.Graduate:
        this.degreeTranslateKey = DegreeName.Second;
        break;
      case TypeName.PhD:
        this.degreeTranslateKey = DegreeName.Third;
        break;
      case TypeName.Postgraduate:
        this.degreeTranslateKey = DegreeName.Postgraduate;
        break;
    }
  }

  getEnrollmentUrl(language: LanguageType): string {
    return isPolishLanguage(language) ? this.getPolishUrls() : this.getEnglishUrls();
  }

  private getPolishUrls() {
    switch (this.localizationTranslateKey) {
      case LocalizationName.Warsaw:
        switch (this.nameTranslateKey) {
          case StudyName.ComputerScience:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/informatyka/inzynierskie/wymagania-inf_i_stac_pol/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/informatyka/informatyka-studia-i-stopnia-niestacjonarne-polskojezyczne/8969-2/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/informatyka/studia-i-stopnia-z-wykorzystaniem-metod-i-technik-ksztalcenia-na-odleglosc/wymagania/';
                }
              case DegreeName.Second:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/informatyka/informatyka-studia-ii-stopnia-stacjonarne-polskojezyczne/8988-2/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/informatyka/studi-ii-stopnia-niestacjonarne/zasady-rekrutacji/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/informatyka/studia-ii-stopnia-z-wykorzystaniem-metod-i-technik-ksztalcenia-na-odleglosc/wymagania/';
                }
              case DegreeName.Third:
                return 'https://pja.edu.pl/szkola-doktorska/';
            }
            break;
          case StudyName.NewMediaArts:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/sztuka-nowych-mediow/licencjackie/zasady-rekrutacji/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/sztuka-nowych-mediow/grafika-sztuka-nowych-mediow-studia-i-stopnia-niestacjonarne-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/sztuka-nowych-mediow/licencjackie/zasady-rekrutacji';
                }
              case DegreeName.Second:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/sztuka-nowych-mediow/magisterskie/zasady-rekrutacji/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/sztuka-nowych-mediow/grafika-sztuka-nowych-mediow-studia-ii-stopnia-niestacjonarne-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/sztuka-nowych-mediow/magisterskie/zasady-rekrutacji';
                }
              case DegreeName.Third:
                return 'https://pja.edu.pl/sztuka-nowych-mediow/kursy-doktoranckie/kursy-i-warsztaty/';
            }
            break;
          case StudyName.InteriorDesign:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/architektura-wnetrz/wymagania-dla-kandydatow/licencjackie-studia-stacjonarne/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/architektura-wnetrz/wymagania-dla-kandydatow/architektura-wnetrz-studia-i-stopnia-niestacjonarne-polskojezyczne/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/architektura-wnetrz/licencjackie/zasady-rekrutacji';
                }
            }
            break;
          case StudyName.InformationManagement:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/zarzadzanie-informacja/zarzadzanie-informacja-studia-i-stopnia-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/zarzadzanie-informacja/zarzadzanie-informacja-studia-i-stopnia-niestacjonarne-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/zarzadzanie-informacja/inzynierskie/zasady-rekrutacji';
                }
              case DegreeName.Second:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/zarzadzanie-informacja/zarzadzanie-informacja-studia-ii-stopnia-stacjonarne-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/zarzadzanie-informacja/zarzadzanie-informacja-studia-ii-stopnia-niestacjonarne-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/zarzadzanie-informacja/magisterskie/zasady-rekrutacji';
                }
            }
            break;
          case StudyName.CultureOfJapan:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/kulturoznawstwo/kultura-japonii-studia-i-stopnia-polskojezyczne/wymagania-dla-kandydatow/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/kulturoznawstwo/kultura-japonii-studia-i-stopnia-niestacjonarne-polskojezyczne/wymagania-dla-kandydatow/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/kultura-japonii/licencjackie/zasady-rekrutacji';
                }
            }
            break;
          case StudyName.GraphicDesign:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/projektowanie-graficzne-i-sztuka-multimediow/projektowanie-graficzne-i-sztuka-multimediow-studia-i-stopnia-stacjonarne-anglojezyczne/wymagania-dla-kandydatow/';
                }
              case DegreeName.Second:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/projektowanie-graficzne-i-sztuka-multimediow/projektowanie-graficzne-i-sztuka-multimediow-studia-ii-stopnia-stacjonarne-anglojezyczne/zasady-rekrutacji/';
                }
            }
            break;
          case StudyName.Postgraduate:
            return 'https://pja.edu.pl/kursy/centrum-ksztalcenia-podyplomowego/';
        }
        break;
      case LocalizationName.Gdansk:
        switch (this.nameTranslateKey) {
          case StudyName.ComputerScience:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://gdansk.pja.edu.pl/informatyka/o-wydziale/informatyka-gdansk-studia-i-stopnia-stacjonarne-polskojezyczne/';
                  case ModeName.PartTime:
                    return 'https://gdansk.pja.edu.pl/informatyka/o-wydziale/informatyka-gdansk-studia-i-stopnia-niestacjonarne-polskojezyczne/';
                }
            }
          case StudyName.NewMediaArts:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://gdansk.pja.edu.pl/grafika-sztuka-nowych-mediow/o-wydziale/grafika-gdansk-studia-i-stopnia-stacjonarne-polskojezyczne/';
                  case ModeName.PartTime:
                    return 'https://gdansk.pja.edu.pl/grafika-sztuka-nowych-mediow/o-wydziale/grafika-gdansk-studia-i-stopnia-niestacjonarne-polskojezyczne/';
                }
              case DegreeName.Second:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://gdansk.pja.edu.pl/grafika-sztuka-nowych-mediow/o-wydziale/grafika-gdansk-studia-ii-stopnia-stacjonarne-polskojezyczne/';
                }
            }
            break;
          case StudyName.Postgraduate:
            return 'https://gdansk.pja.edu.pl/pl/grafika#podyplomowe';
        }
        break;
      case LocalizationName.Bytom:
        switch (this.nameTranslateKey) {
          case StudyName.ComputerScience:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/informatyka-bytom/informatyka-bytom-studia-i-stopnia-stacjonarne-polskojezyczne/o-programie/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/informatyka-bytom/informatyka-bytom-studia-i-stopnia-niestacjonarne-polskojezyczne/o-wydziale/';
                }
            }
        }
        break;
    }
  }

  private getEnglishUrls() {
    switch (this.localizationTranslateKey) {
      case LocalizationName.Warsaw:
        switch (this.nameTranslateKey) {
          case StudyName.ComputerScience:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/informatyka/inzynierskie/wymagania-inf_i_stac_pol/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/en/informatyka/informatyka-studia-i-stopnia-niestacjonarne-polskojezyczne/8969-2/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/en/informatyka/studia-i-stopnia-z-wykorzystaniem-metod-i-technik-ksztalcenia-na-odleglosc/wymagania/';
                }
              case DegreeName.Second:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/informatyka/informatyka-studia-ii-stopnia-stacjonarne-polskojezyczne/8988-2/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/en/informatyka/studi-ii-stopnia-niestacjonarne/zasady-rekrutacji/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/en/informatyka/studia-ii-stopnia-z-wykorzystaniem-metod-i-technik-ksztalcenia-na-odleglosc/wymagania/';
                }
              case DegreeName.Third:
                return 'https://pja.edu.pl/en/szkola-doktorska/';
            }
            break;
          case StudyName.NewMediaArts:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/sztuka-nowych-mediow/licencjackie/zasady-rekrutacji/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/en/sztuka-nowych-mediow/grafika-sztuka-nowych-mediow-studia-i-stopnia-niestacjonarne-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/en/sztuka-nowych-mediow/licencjackie/zasady-rekrutacji/';
                }
              case DegreeName.Second:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/sztuka-nowych-mediow/magisterskie/zasady-rekrutacji/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/en/sztuka-nowych-mediow/grafika-sztuka-nowych-mediow-studia-ii-stopnia-niestacjonarne-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/en/sztuka-nowych-mediow/magisterskie/zasady-rekrutacji/';
                }
              case DegreeName.Third:
                return 'https://pja.edu.pl/en/sztuka-nowych-mediow/kursy-doktoranckie/kursy-i-warsztaty/';
            }
            break;
          case StudyName.InteriorDesign:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/architektura-wnetrz/wymagania-dla-kandydatow/licencjackie-studia-stacjonarne/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/en/architektura-wnetrz/wymagania-dla-kandydatow/architektura-wnetrz-studia-i-stopnia-niestacjonarne-polskojezyczne/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/en/architektura-wnetrz/licencjackie/zasady-rekrutacji';
                }
            }
            break;
          case StudyName.InformationManagement:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/zarzadzanie-informacja/zarzadzanie-informacja-studia-i-stopnia-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/en/zarzadzanie-informacja/zarzadzanie-informacja-studia-i-stopnia-niestacjonarne-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/en/zarzadzanie-informacja/inzynierskie/zasady-rekrutacji';
                }
              case DegreeName.Second:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/zarzadzanie-informacja/zarzadzanie-informacja-studia-ii-stopnia-stacjonarne-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/en/zarzadzanie-informacja/zarzadzanie-informacja-studia-ii-stopnia-niestacjonarne-polskojezyczne/zasady-rekrutacji/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/en/zarzadzanie-informacja/magisterskie/zasady-rekrutacji';
                }
            }
            break;
          case StudyName.CultureOfJapan:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/kulturoznawstwo/kultura-japonii-studia-i-stopnia-polskojezyczne/wymagania-dla-kandydatow/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/en/kulturoznawstwo/kultura-japonii-studia-i-stopnia-niestacjonarne-polskojezyczne/wymagania-dla-kandydatow/';
                  case ModeName.Internet:
                    return 'https://pja.edu.pl/en/kultura-japonii/licencjackie/zasady-rekrutacji';
                }
            }
            break;
          case StudyName.GraphicDesign:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/projektowanie-graficzne-i-sztuka-multimediow/projektowanie-graficzne-i-sztuka-multimediow-studia-i-stopnia-stacjonarne-anglojezyczne/wymagania-dla-kandydatow/';
                }
              case DegreeName.Second:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/projektowanie-graficzne-i-sztuka-multimediow/projektowanie-graficzne-i-sztuka-multimediow-studia-ii-stopnia-stacjonarne-anglojezyczne/zasady-rekrutacji/';
                }
            }
            break;
          case StudyName.Postgraduate:
            return 'https://pja.edu.pl/en/kursy/centrum-ksztalcenia-podyplomowego/';
        }
        break;
      case LocalizationName.Gdansk:
        switch (this.nameTranslateKey) {
          case StudyName.ComputerScience:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://gdansk.pja.edu.pl/informatyka/o-wydziale/informatyka-gdansk-studia-i-stopnia-stacjonarne-polskojezyczne/';
                  case ModeName.PartTime:
                    return 'https://gdansk.pja.edu.pl/informatyka/o-wydziale/informatyka-gdansk-studia-i-stopnia-niestacjonarne-polskojezyczne/';
                }
            }
          case StudyName.NewMediaArts:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://gdansk.pja.edu.pl/grafika-sztuka-nowych-mediow/o-wydziale/grafika-gdansk-studia-i-stopnia-stacjonarne-polskojezyczne/';
                  case ModeName.PartTime:
                    return 'https://gdansk.pja.edu.pl/grafika-sztuka-nowych-mediow/o-wydziale/grafika-gdansk-studia-i-stopnia-niestacjonarne-polskojezyczne/';
                }
              case DegreeName.Second:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://gdansk.pja.edu.pl/grafika-sztuka-nowych-mediow/o-wydziale/grafika-gdansk-studia-ii-stopnia-stacjonarne-polskojezyczne/';
                }
            }
            break;
          case StudyName.Postgraduate:
            return 'https://gdansk.pja.edu.pl/pl/grafika#podyplomowe';
        }
        break;
      case LocalizationName.Bytom:
        switch (this.nameTranslateKey) {
          case StudyName.ComputerScience:
            switch (this.degreeTranslateKey) {
              case DegreeName.First:
                switch (this.modeTranslateKey) {
                  case ModeName.FullTime:
                    return 'https://pja.edu.pl/en/informatyka-bytom/informatyka-bytom-studia-i-stopnia-stacjonarne-polskojezyczne/o-programie/';
                  case ModeName.PartTime:
                    return 'https://pja.edu.pl/en/informatyka-bytom/informatyka-bytom-studia-i-stopnia-niestacjonarne-polskojezyczne/o-wydziale/';
                }
            }
        }
        break;
    }
  }
}
